<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('coding_search_button')"
          type="primary"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button v-if="getLimit('coding_new_button')" @click="funcAdd()">
          新增
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="partyType"
          :formatter="formatterpartyType"
          title="用户类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.partyType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in partyTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerName"
          title="付款方户名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerName"
            placeholder="请输入付款方户名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="收款方户名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入收款方户名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fixPayeeCardNo"
          title="收款方卡号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.fixPayeeCardNo"
            placeholder="请输入收款方卡号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentAmount"
          title="账户余额（元）"
          width="220"
          sortable
        />
        <template v-slot:header>
          <div class="for-input-range">
            <el-input
              v-model="listQuery.shipmentAmountStart"
              placeholder="下限"
              clearable
              @input="
                value =>
                  formFormatter.isFloor2(
                    value,
                    oldValue,
                    listQuery,
                    'shipmentAmountStart'
                  )
              "
            />
            <el-input
              v-model="listQuery.shipmentAmountEnd"
              placeholder="上限"
              clearable
              @input="
                value =>
                  formFormatter.isFloor2(
                    value,
                    oldValue,
                    listQuery,
                    'shipmentAmountEnd'
                  )
              "
            />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('withdraw_deposit_button') &&
                scope.row.partyType == 'PLAT'
            "
            class="item"
            effect="dark"
            content="提现"
            placement="top"
          >
            <vxe-button type="text" @click="showModel(scope.row, 'Deposit')">
              <i class="el-icon-wallet" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('Withdrawal_record_button') &&
                scope.row.partyType == 'PLAT'
            "
            class="item"
            effect="dark"
            content="提现记录"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="showModel(scope.row.partyCode, 'Record')"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelEditFlag"
      :title="compTitle"
      width="600"
      height="280"
      resize
    >
      <compAdd
        ref="AddRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelRecordFlag"
      width="1200"
      height="80%"
      title="提现记录"
      resize
    >
      <CompRecord ref="RecordRef" />
    </vxe-modal>
    <vxe-modal
      v-model="modelDepositFlag"
      title="提现"
      width="600"
      height="400"
      resize
    >
      <CompDeposit
        ref="DepositRef"
        @fatherDepositMethod="fatherDeposit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/CodingAdd.vue";
import CompRecord from "./components/Withdrawalrecord.vue";
import CompDeposit from "./components/deposit.vue";
import { shipmentPaidRecord } from "@/api/collectioncoding";
import { isNumber } from "@/utils/validate.js";
export default {
  components: {
    compAdd,
    CompRecord,
    CompDeposit
  },
  data() {
    return {
      message: "",
      compTitle: "新增收款编码",
      loading: false,
      tableData: [],
      modelEditFlag: false,
      modelRecordFlag: false,
      modelDepositFlag: false,
      listQuery: {
        partyType: "",
        payerName: "",
        payeeName: "",
        shipmentAmount: "",
        shipmentAmountStart: "",
        shipmentAmountEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      partyTypeOptions: [
        {
          label: "平台",
          value: "PLAT"
        },
        {
          label: "托运人",
          value: "SHIPMENT"
        }
      ],
      // Pagingconf: [],
      sumObject: {},
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    fatherDeposit() {
      this.modelDepositFlag = false;
      this.findList();
    },
    // 展示弹框
    showModel(code, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].findList(code);
      }
      this[`model${prefix}Flag`] = true;
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "edit":
          this.modelEditFlag = false;
          break;
        case "Deposit":
          this.modelDepositFlag = false;
          break;
        default:
      }
    },
    funcAdd() {
      this.$refs.AddRef.getInfo();
      this.modelEditFlag = true;
    },
    isNumber4listQuery(key) {
      let val = this.listQuery[key];
      if (val !== "") {
        if (!isNumber(val)) {
          this.$message({ message: "请输入数字！", type: "error" });
        }
        val = parseFloat(val);
        if (isNaN(val)) {
          val = "";
        }
        this.$set(this.listQuery, key, val);
      }
    },
    formatterpartyType({ cellValue }) {
      switch (cellValue) {
        case "PLAT":
          return "平台";
        case "SHIPMENT":
          return "托运人";
        default:
          break;
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        shipmentPaidRecord(this.listQuery).then(response => {
          this.tableData = response.data.records;
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>

<style></style>
